import type { App } from 'vue';

import {
  buildMultilingualString,
  getAvailableLocales,
  getTextForLocaleStatic,
  parseMultilingualString,
  translateMultilingualArray,
  translateMultilingualValuesInObject,
} from '@/utils/multilingualCore';

export default {
  install(app: App) {
    app.config.globalProperties.$getTextForLocale = getTextForLocaleStatic;
    app.config.globalProperties.$parseMultilingualString = parseMultilingualString;
    app.config.globalProperties.$buildMultilingualString = buildMultilingualString;
    app.config.globalProperties.$getAvailableLocales = getAvailableLocales;
    app.config.globalProperties.$translateMultilingualValuesInObject =
      translateMultilingualValuesInObject;
    app.config.globalProperties.$translateMultilingualArray = translateMultilingualArray;
  },
};
